// Mock data for The Benne Corner website
// This will be replaced by CMS-driven data from backend later

export const initialContent = {
  brand: {
    name: "The Benne Corner",
    tagline: "Authentic South Indian Cafe",
    logo: "https://customer-assets.emergentagent.com/job_details-manager-2/artifacts/vmirgruj_WhatsApp%20Image%202026-06-12%20at%202.36.41%20PM.jpeg",
  },
  nav: [
    { label: "HOME", href: "#home" },
    { label: "ABOUT", href: "#about" },
    { label: "MENU", href: "#menu" },
    { label: "GALLERY", href: "#gallery" },
    { label: "FRANCHISE", href: "#franchise" },
  ],
  hero: {
    eyebrow: "",
    title: "Authentic South Indian",
    subtitle: "A premium cafe experience rooted in tradition.",
    bgImage:
      "https://images.unsplash.com/photo-1555396273-367ea4eb4db5?auto=format&fit=crop&w=2000&q=80",
    primaryCta: { label: "VISIT US", href: "#contact" },
    secondaryCta: { label: "FRANCHISE INQUIRY", href: "#franchise" },
  },
  about: {
    eyebrow: "OUR STORY",
    title: "Heritage meets luxury.",
    description:
      "The Benne Corner brings authentic South Indian flavours with traditional recipes, premium ingredients, and a modern cafe experience. Founded with a passion for preserving the rich culinary heritage of South India, we serve every dish with the warmth of home and the precision of a premium establishment.",
    features: [
      {
        icon: "Utensils",
        title: "Authentic Taste",
        text: "True flavors from the heart of South India.",
      },
      {
        icon: "Award",
        title: "Quality Ingredients",
        text: "Premium sourced spices and fresh produce.",
      },
      {
        icon: "Coffee",
        title: "Traditional Recipes",
        text: "Generations-old recipes perfectly preserved.",
      },
      {
        icon: "TrendingUp",
        title: "Growing Franchise",
        text: "A lucrative opportunity to partner with us.",
      },
    ],
  },
  menu: {
    eyebrow: "OUR OFFERINGS",
    title: "Culinary Masterpieces",
    categories: ["All", "Beverages", "Dosas", "Idli & Vada", "Specials"],
    items: [
      {
        id: "m1",
        category: "Beverages",
        name: "Badam Milk",
        price: 60,
        description:
          "Rich almond milk sweetened with saffron and cardamom, served chilled",
        image:
          "https://images.unsplash.com/photo-1572490122747-3968b75cc699?auto=format&fit=crop&w=900&q=80",
      },
      {
        id: "m2",
        category: "Beverages",
        name: "Filter Coffee",
        price: 40,
        description:
          "Traditional South Indian filter coffee, brewed with premium Coorg beans and fresh milk",
        image:
          "https://images.unsplash.com/photo-1509042239860-f550ce710b93?auto=format&fit=crop&w=900&q=80",
      },
      {
        id: "m3",
        category: "Beverages",
        name: "Masala Tea",
        price: 35,
        description:
          "Aromatic spiced tea brewed with ginger, cardamom and fresh herbs",
        image:
          "https://images.unsplash.com/photo-1571934811356-5cc061b6821f?auto=format&fit=crop&w=900&q=80",
      },
      {
        id: "m4",
        category: "Dosas",
        name: "Benne Dosa",
        price: 80,
        description:
          "Crispy butter dosa made with the finest fermented batter, served with coconut chutney and sambar",
        image:
          "https://images.pexels.com/photos/20422121/pexels-photo-20422121.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
      },
      {
        id: "m5",
        category: "Dosas",
        name: "Masala Dosa",
        price: 90,
        description:
          "Classic crispy dosa stuffed with spiced potato filling, served with three chutneys",
        image:
          "https://images.pexels.com/photos/20422123/pexels-photo-20422123.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
      },
      {
        id: "m6",
        category: "Dosas",
        name: "Rava Dosa",
        price: 85,
        description:
          "Crispy instant dosa made with semolina, perfect crunch with every bite",
        image:
          "https://images.pexels.com/photos/20422121/pexels-photo-20422121.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
      },
      {
        id: "m7",
        category: "Dosas",
        name: "Set Dosa",
        price: 70,
        description:
          "Soft, fluffy set of three small dosas with coconut chutney and vegetable kurma",
        image:
          "https://images.pexels.com/photos/20422123/pexels-photo-20422123.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
      },
      {
        id: "m8",
        category: "Idli & Vada",
        name: "Idli (2 pcs)",
        price: 50,
        description:
          "Steamed rice cakes, soft as clouds, served with sambar and three chutneys",
        image:
          "https://images.pexels.com/photos/4331491/pexels-photo-4331491.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
      },
      {
        id: "m9",
        category: "Idli & Vada",
        name: "Idli Vada Combo",
        price: 90,
        description:
          "Two steamed idlis and one crispy vada - the perfect South Indian breakfast",
        image:
          "https://images.pexels.com/photos/25451535/pexels-photo-25451535.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
      },
      {
        id: "m10",
        category: "Idli & Vada",
        name: "Medu Vada",
        price: 60,
        description:
          "Golden, crispy lentil fritters with a soft interior, served hot with chutney",
        image:
          "https://images.pexels.com/photos/21751212/pexels-photo-21751212.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
      },
      {
        id: "m11",
        category: "Specials",
        name: "Pongal",
        price: 70,
        description:
          "Warm, comforting rice and lentil khichdi tempered with ghee, cumin and cashews",
        image:
          "https://images.pexels.com/photos/18305749/pexels-photo-18305749.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
      },
      {
        id: "m12",
        category: "Specials",
        name: "Upma",
        price: 60,
        description:
          "Savory semolina porridge cooked with vegetables, seasoned with mustard and curry leaves",
        image:
          "https://images.pexels.com/photos/35514447/pexels-photo-35514447.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
      },
    ],
  },
  videos: {
    eyebrow: "WATCH",
    title: "Our Story in Motion",
    items: [
      {
        id: "v1",
        title: "Our Kitchen Story",
        thumbnail:
          "https://images.pexels.com/photos/20422121/pexels-photo-20422121.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
        youtubeId: "7y1IjsZG-PE",
      },
      {
        id: "v2",
        title: "The Art of Dosa",
        thumbnail:
          "https://images.pexels.com/photos/20422123/pexels-photo-20422123.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
        youtubeId: "5x9NopRG4dM",
      },
    ],
  },
  testimonials: {
    eyebrow: "WHAT OUR GUESTS SAY",
    title: "Real Stories from Real Guests",
    items: [
      {
        id: "t1",
        name: "Priya Sharma",
        when: "2 weeks ago",
        avatar:
          "https://images.pexels.com/photos/17248602/pexels-photo-17248602.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=200&w=200",
        rating: 5,
        text: "Absolutely loved the Benne Dosa! The butter aroma takes you back to an authentic South Indian kitchen. The filter coffee is genuinely the best I've had outside Bangalore.",
      },
      {
        id: "t2",
        name: "Rahul Verma",
        when: "1 month ago",
        avatar:
          "https://images.pexels.com/photos/12396627/pexels-photo-12396627.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=200&w=200",
        rating: 5,
        text: "A premium experience! The ambiance, the service, and the food - all top-notch. Idli Vada combo was fluffy and perfectly served. Highly recommend the Pongal too.",
      },
      {
        id: "t3",
        name: "Anita Iyer",
        when: "3 weeks ago",
        avatar:
          "https://images.pexels.com/photos/27086922/pexels-photo-27086922.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=200&w=200",
        rating: 5,
        text: "Finally a place that respects authentic flavors! The Masala Dosa was crispy and the sambar reminded me of my grandmother's. A true gem.",
      },
    ],
    reviewLink: "https://www.google.com/maps",
  },
  franchise: {
    eyebrow: "PARTNER WITH US",
    title: "Build a legacy.",
    subtitle: "Join The Benne Corner family.",
    description:
      "We are expanding across India. If you share our passion for authentic South Indian cuisine and premium hospitality, we want to hear from you.",
    bullets: [
      { title: "High ROI", text: "Proven business model with strong margins" },
      {
        title: "Full Support",
        text: "Comprehensive training and marketing assistance",
      },
    ],
    whatsappNumber: "919727567740",
    budgetOptions: [
      "5-10 Lakhs",
      "10-20 Lakhs",
      "20-50 Lakhs",
      "50+ Lakhs",
    ],
  },
  contact: {
    eyebrow: "VISIT US",
    title: "Find Your Way to Us",
    address:
      "The Benne Corner - The OG Banglorian Dosa, Surat, Gujarat",
    phone: "+91 97275 67740",
    email: "hello@thebennecorner.com",
    mapsUrl: "https://maps.app.goo.gl/96KoCpvQZ99YAYZN8",
    whatsappUrl:
      "https://wa.me/919727567740?text=Hello!%20I%20am%20interested%20in%20The%20Benne%20Corner.",
  },
  footer: {
    copyright: "© 2026 The Benne Corner. All rights reserved.",
  },
};
